import { render, staticRenderFns } from "./Join2.vue?vue&type=template&id=c6b27f34&"
import script from "./Join2.vue?vue&type=script&lang=js&"
export * from "./Join2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports